/**
 * @generated SignedSource<<c2f2855349ae9e708b9e9042940b71d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Type = "PRAISE" | "REQUESTED" | "UNSOLICITED";
import { FragmentRefs } from "relay-runtime";
export type FeedbackCardFeedback$data = {
  readonly creator: {
    readonly email: string;
    readonly firstName: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
    readonly lastName: string;
  } | null;
  readonly id: string;
  readonly isAnonymous: boolean;
  readonly isArchived: boolean;
  readonly isDraft: boolean;
  readonly isMeetingFeedback: boolean;
  readonly isThreeSixtyParent: boolean;
  readonly lastSeenByUser: string | null;
  readonly recipients: ReadonlyArray<{
    readonly shared: boolean;
    readonly user: {
      readonly id: string;
    };
  }>;
  readonly requestCount: number;
  readonly responseCount: number;
  readonly sharedWithMe: boolean;
  readonly title: string;
  readonly type: Type;
  readonly updatedAt: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackSubject_item">;
  readonly " $fragmentType": "FeedbackCardFeedback";
};
export type FeedbackCardFeedback$key = {
  readonly " $data"?: FeedbackCardFeedback$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCardFeedback">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackCardFeedback",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FeedbackSubject_item"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDraft",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastSeenByUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMeetingFeedback",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sharedWithMe",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isThreeSixtyParent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnonymous",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeedbackRecipientNode",
      "kind": "LinkedField",
      "name": "recipients",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shared",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedbackNode",
  "abstractKey": null
};
})();

(node as any).hash = "a44ea0e9ff95c8b91b943c2ff27b3341";

export default node;
